import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { fmtMoney } from 'utilities/format';

/**
 * Five-tile money summary on the order detail dialog.
 * The discount tile is conditional on `discount_total > 0`.
 */
export default function OrderSummaryTiles({ order: o }) {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing='12px' mb='14px' flexWrap='wrap'>
      <Box bgcolor='action.hover' p='10px' borderRadius='10px' flex='1'>
        <Typography variant='caption' color='text.secondary'>Subtotal</Typography>
        <Typography variant='body1' fontWeight='700'>{fmtMoney(o.subtotal, o.currency)}</Typography>
      </Box>
      {Number(o.discount_total || 0) > 0 && (
        <Box bgcolor='action.hover' p='10px' borderRadius='10px' flex='1'>
          <Typography variant='caption' color='text.secondary'>
            Discount{o.discount_code ? ` (${o.discount_code})` : ''}
          </Typography>
          <Typography variant='body1' fontWeight='700' color='error.main'>
            -{fmtMoney(o.discount_total, o.currency)}
          </Typography>
        </Box>
      )}
      <Box bgcolor='action.hover' p='10px' borderRadius='10px' flex='1'>
        <Typography variant='caption' color='text.secondary'>Tax</Typography>
        <Typography variant='body1' fontWeight='700'>{fmtMoney(o.tax_total, o.currency)}</Typography>
      </Box>
      <Box bgcolor='action.hover' p='10px' borderRadius='10px' flex='1'>
        <Typography variant='caption' color='text.secondary'>Shipping</Typography>
        <Typography variant='body1' fontWeight='700'>{fmtMoney(o.shipping_total, o.currency)}</Typography>
      </Box>
      <Box bgcolor='success.light' p='10px' borderRadius='10px' flex='1'>
        <Typography variant='caption' color='text.secondary'>Total</Typography>
        <Typography variant='body1' fontWeight='700'>{fmtMoney(o.grand_total, o.currency)}</Typography>
      </Box>
    </Stack>
  );
}
